import { whiteLabelRegistry } from "./registry";

export default class DomainHandler {
  private static _cachedApiDomain: string | null = null;
  private static _cachedHostname: string | null = null;

  static getHostname(): string {
    if (this._cachedHostname !== null) {
      return this._cachedHostname;
    }
    this._cachedHostname = this.getEnvAndHostname().hostname;
    return this._cachedHostname;
  }

  static getEnvAndHostname(): { env: "dev" | "stg" | "prod" | "local"; hostname: string } {
    try {
      let env = "prod";
      const hostnameRegex = /^(.*)\.white-label-compass\.com$/;
      const winHostname = window.location.hostname;
      const match = winHostname.match(hostnameRegex);
      let hostname = match ? match[1] : winHostname;

      if (
        hostname.startsWith("dev-") ||
        hostname.startsWith("stg-") ||
        hostname.startsWith("dev.") ||
        hostname.startsWith("stg.")
      ) {
        env = hostname.substring(0, 3) as "dev" | "stg";
        hostname = hostname.substring(4);
      }

      hostname = hostname.replace(/^(https?:\/\/)?(www\.)?/, "");
      hostname = hostname.replace(/[.-]/g, "_");
      hostname = hostname.includes("speedcast") ? "default" : hostname;
      if (hostname.includes("localhost")) {
        const urlParams = new URLSearchParams(window.location.search);
        hostname = urlParams.get("tenant") || "default";
        // hostname = "default";
        env = "local";
        console.log("hostname:", hostname);
      }

      return { env: env as "dev" | "stg" | "prod" | "local", hostname };
    } catch (error) {
      return { env: "prod", hostname: "default" };
    }
  }

  static resolveApiDomain(): string {
    if (this._cachedApiDomain !== null) {
      return this._cachedApiDomain;
    }

    try {
      const apiDomain = whiteLabelRegistry.getVariable("apiDomain");
      this._cachedApiDomain = apiDomain || import.meta.env.VITE_API_URL;
      return this._cachedApiDomain!;
    } catch (error) {
      this._cachedApiDomain = import.meta.env.VITE_API_URL;
      return this._cachedApiDomain!;
    }
  }

  static _clearCache(): void {
    this._cachedApiDomain = null;
    this._cachedHostname = null;
  }
}
